export type RatingRow = { criteria: string; rating: number | string; remarks: string }
export type ResourceRow = { criteria: string; rating: string; remarks: string; href?: string }

export const isCheatScoreHigh = (score?: number) => typeof score === 'number' && score >= 6.5

export const normalizeRows = (items?: any[]): RatingRow[] => {
  if (!Array.isArray(items)) return []
  return items.map((item, idx) => ({
    criteria:
      item?.criteria ||
      item?.title ||
      item?.name ||
      item?.question ||
      item?.concept ||
      item?.concepts ||
      item?.skill ||
      `Item ${idx + 1}`,
    rating: item?.rating ?? item?.score ?? '-',
    remarks:
      item?.remarks ||
      item?.remark ||
      item?.comments ||
      item?.description ||
      item?.summary ||
      item?.reason ||
      item?.feedback ||
      '',
  }))
}

export const getSummaryText = (summary: any): string =>
  typeof summary === 'string' ? summary : summary?.text || ''

export const normalizeProfessionalExperience = (items?: any[]): RatingRow[] => {
  if (!Array.isArray(items)) return []
  return items.map((item, idx) => ({
    criteria: item?.summary || item?.title || `Experience ${idx + 1}`,
    rating:
      item?.match_percentage !== undefined
        ? Math.round(Number(item.match_percentage) / 10)
        : '-',
    remarks: item?.strengths?.join(', ') || item?.remarks || '',
  }))
}

export const normalizeScreening = (items?: any[]): RatingRow[] => {
  if (!Array.isArray(items)) return []
  return items.map((item, idx) => ({
    criteria: item?.question || item?.criteria || `Question ${idx + 1}`,
    rating: item?.rating ?? item?.score ?? '-',
    remarks: item?.answer || item?.remarks || '',
  }))
}

export const normalizeResources = (items?: any[]): ResourceRow[] => {
  if (!Array.isArray(items)) return []
  return items.map((item, idx) => ({
    criteria: item?.title || item?.name || `Resource ${idx + 1}`,
    rating: item?.type || item?.category || 'Resource',
    remarks: item?.description || item?.summary || '',
    href: item?.link || item?.url,
  }))
}

